import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { NavProvider } from "./context/NavContext";
import MobileNav from "./components/MobileNav";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Cookingclass from "./pages/Cookingclass";
import Experiences from "./pages/Experiences";
import Forestdouble from "./pages/Forestdouble";
import Foresttriple from "./pages/Foresttriple";
import Foresttwin from "./pages/Foresttwin";
import Gallery from "./pages/Gallery";
import Hanthanarange from "./pages/Hanthanarange";
import Peakfamily from "./pages/Peakfamily";
import Peakroom from "./pages/Peakroom";
import Peakoe from "./pages/Pekoe";
import Rooms from "./pages/Rooms";
import Teafactoryvisits from "./pages/Teafactoryvisits";

function App() {
  return (
    <BrowserRouter>
      <NavProvider>
        <MobileNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cookingclass" element={<Cookingclass />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/forestdouble" element={<Forestdouble />} />
          <Route path="/foresttriple" element={<Foresttriple />} />
          <Route path="/foresttwin" element={<Foresttwin />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/hanthanarange" element={<Hanthanarange />} />
          <Route path="/peakfamily" element={<Peakfamily />} />
          <Route path="/peakroom" element={<Peakroom />} />
          <Route path="/pekoe" element={<Peakoe />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/teafactoryvisits" element={<Teafactoryvisits />} />
        </Routes>
      </NavProvider>
    </BrowserRouter>
  );
}

export default App;
